import React, { useState, useEffect } from 'react';
import Modal from './Modal';
import Button from './Buttons';

// Generic destructive-action modal (same pattern as DeleteAssessmentModal / ReassessModal):
// step 1 explains the consequences, step 2 requires typing "Confirm".
// Pass requireTyping={false} for a single-step confirm (message + Cancel/Delete, no typing) —
// used where the action is real but low-ceremony (e.g. Live Monitoring removal).
const ConfirmDeleteModal = ({ isOpen, onClose, onConfirm, title, message, confirmLabel = 'Delete', isBusy = false, requireTyping = true }) => {
  const [step, setStep] = useState(1);
  const [confirmText, setConfirmText] = useState('');

  useEffect(() => {
    if (isOpen) {
      setStep(1);
      setConfirmText('');
    }
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} size="md">
      {step === 1 ? (
        <div>
          <p className="text-sm text-content-primary mb-6 whitespace-pre-line">{message}</p>
          <div className="flex justify-end space-x-3">
            <Button variant="secondary" onClick={onClose}>{requireTyping ? 'Go Back' : 'Cancel'}</Button>
            {requireTyping ? (
              <Button variant="danger" onClick={() => setStep(2)}>Yes</Button>
            ) : (
              <Button variant="danger" disabled={isBusy} onClick={onConfirm}>
                {isBusy ? 'Working…' : confirmLabel}
              </Button>
            )}
          </div>
        </div>
      ) : (
        <div>
          <p className="text-sm text-content-primary mb-4">
            Type <span className="font-semibold">Confirm</span> to proceed.
          </p>
          <input
            type="text"
            value={confirmText}
            onChange={(e) => setConfirmText(e.target.value)}
            placeholder="Type 'Confirm' here"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 mb-4"
            autoFocus
          />
          <div className="flex justify-end space-x-3">
            <Button variant="secondary" onClick={onClose}>Go Back</Button>
            <Button variant="danger" disabled={confirmText !== 'Confirm' || isBusy} onClick={onConfirm}>
              {isBusy ? 'Working…' : confirmLabel}
            </Button>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default ConfirmDeleteModal;
